import * as React from "react";
import type { SVGProps } from "react";
const SvgGiveBackMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m32.98 45.86-1.33-1.2c-2.29-2.1-4.19-3.91-5.68-5.44-1.49-1.53-2.68-2.89-3.57-4.09-.89-1.2-1.51-2.29-1.87-3.26a8.46 8.46 0 0 1-.54-2.96c0-1.95.65-3.58 1.96-4.89 1.31-1.31 2.93-1.96 4.86-1.96 1.23 0 2.38.29 3.43.88 1.05.58 1.96 1.43 2.74 2.53.91-1.17 1.87-2.03 2.89-2.58 1.02-.55 2.11-.83 3.28-.83 1.93 0 3.55.65 4.86 1.96 1.31 1.31 1.96 2.94 1.96 4.89 0 1-.18 1.98-.54 2.96-.36.97-.98 2.06-1.87 3.26-.89 1.2-2.08 2.57-3.57 4.09-1.49 1.53-3.39 3.34-5.68 5.44l-1.33 1.2Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M33.01 60.34c15.652 0 28.34-12.688 28.34-28.34S48.662 3.66 33.01 3.66 4.67 16.348 4.67 32s12.688 28.34 28.34 28.34Z"
    />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M8.38 25.25a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76Z"
    />
    <path
      fill="#26A3DD"
      d="M10.94 17.18H9.06V15.3H7.69v1.88H5.81v1.37h1.88v1.88h1.37v-1.88h1.88v-1.37Z"
    />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M57.62 53.58a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76Z"
    />
    <path
      fill="#26A3DD"
      d="M60.19 45.51H58.3v-1.88h-1.37v1.88h-1.88v1.37h1.88v1.88h1.37v-1.88h1.89v-1.37Z"
    />
  </svg>
);
export default SvgGiveBackMore;
